import { isFeatureGateEnabled } from '@/lib/feature-gates';

export const formFieldDisplayConfig = {
  get showRequiredAsterisk() {
    return isFeatureGateEnabled('formRequiredMarkers');
  },
  get reserveErrorMessageSpace() {
    return isFeatureGateEnabled('formReservedErrorSpace');
  },
} as const;
